// extracted by mini-css-extract-plugin
export var ani = "LoadingAnimation-module--ani--f0593";
export var container = "LoadingAnimation-module--container--3049a";
export var inner = "LoadingAnimation-module--inner--1299d";
export var s1 = "LoadingAnimation-module--s1--a02fb";
export var s2 = "LoadingAnimation-module--s2--89a72";
export var s3 = "LoadingAnimation-module--s3--2f47e";